/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advancedtitle1Inputs */

const en_advancedtitle1 = /** @type {(inputs: Advancedtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced`)
};

const de_advancedtitle1 = /** @type {(inputs: Advancedtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweitert`)
};

/**
* | output |
* | --- |
* | "Advanced" |
*
* @param {Advancedtitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const advancedtitle1 = /** @type {((inputs?: Advancedtitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advancedtitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_advancedtitle1(inputs)
	return de_advancedtitle1(inputs)
});
export { advancedtitle1 as "advancedTitle" }